$(document).ready(function() {
    let $reviewsSlider = $('.dtc-reviews-carousel');

    $reviewsSlider.flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false
    });

    let flkty = $reviewsSlider.data('flickity');
    if (flkty.selectedIndex === 0){
        $('.dtc-reviews-carousel__prevArrow').hide();
    }
    $reviewsSlider.css('height', 'fit-content');

    $('.dtc-reviews-carousel__prevArrow').on('click', function() {
        $reviewsSlider.flickity('previous');
        let flkty = $reviewsSlider.data('flickity');
        if (flkty.selectedIndex === 0){
            $(this).hide();
        }
        if (flkty.selectedIndex !== flkty.cells.length - 1){
            $('.dtc-reviews-carousel__nextArrow').show();
        }
    });

    $('.dtc-reviews-carousel__nextArrow').on('click', function() {
        $reviewsSlider.flickity('next');
        let flkty = $reviewsSlider.data('flickity');
        if (flkty.selectedIndex === flkty.cells.length - 1){
            $(this).hide();
        }
        if (flkty.selectedIndex !== 0){
            $('.dtc-reviews-carousel__prevArrow').show();
        }
    });
});